import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Box } from '@bonanza-social/moonlight';
import { BottomSheetBackgroundProps } from './BottomSheetModal.types';

function BottomSheetBackground({
  light,
  borderStyle,
  borderGradient,
  ...props
}: BottomSheetBackgroundProps) {
  const colorProps = useMemo(
    () =>
      light
        ? {
            variant: 'gradient',
            gradient: 'accentBackground',
          }
        : {
            backgroundColor: 'primaryBackground',
            variant: 'default',
          },
    [light],
  );

  const borderStyleProps = useMemo(() => {
    switch (borderStyle) {
      case 'allsides':
        return {
          top: 'space-100',
          left: 'space-100',
          bottom: 'space-100',
          right: 'space-100',
        };
      case 'top':
      default:
        return {
          top: 'space-100',
          left: 'space-0',
          bottom: 'space-0',
          right: 'space-0',
        };
    }
  }, [borderStyle]);

  return (
    <View {...props} pointerEvents="none">
      <Box
        position="absolute"
        borderRadius="radius-600"
        top="space-0"
        bottom="space-0"
        right="space-0"
        left="space-0"
        variant="gradient"
        overflow="hidden"
        gradient={borderGradient}
      >
        <Box
          position="absolute"
          borderRadius="radius-600"
          {...colorProps}
          {...borderStyleProps}
        />
      </Box>
    </View>
  );
}

export default BottomSheetBackground;
